<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div
  class="flex mt-fluid-sm"
  role="progressbar"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="3"
  [attr.aria-valuenow]="passwordStrength.id ?? 0"
  [attr.aria-label]="'signup.password.strength.indicator.headlineLabel' | translate"
>
  @for (strengthItem of strengthItems; track $index) {
    <div [ngClass]="strengthItem" class="strength__item me-static-xs"></div>
  }
</div>

<p-text size="sm" class="inline-block mt-fluid-xs me-static-xs" aria-hidden="true">{{
  'signup.password.strength.indicator.headlineLabel' | translate
}}</p-text>
@switch (passwordStrength.id) {
  @default {
    <p-text tag="span" size="sm" class="ms-static-xs inline-block" aria-hidden="true">{{
      'signup.password.strength.indicator.weakLabel' | translate
    }}</p-text>
  }
  @case (2) {
    <p-text tag="span" size="sm" class="ms-static-xs inline-block" aria-hidden="true">{{
      'signup.password.strength.indicator.mediumLabel' | translate
    }}</p-text>
  }
  @case (3) {
    <p-text tag="span" size="sm" class="ms-static-xs inline-block" aria-hidden="true">{{
      'signup.password.strength.indicator.strongLabel' | translate
    }}</p-text>
  }
}

<span class="sr-only" aria-live="polite" data-testid="password-strength-announcement">
  @if (strengthAnnouncementLabelKey) {
    {{ 'signup.password.strength.indicator.announcement' | translate: { strength: strengthAnnouncementLabelKey | translate } }}
  }
</span>

@if (passwordCriteriaVisible) {
  <div>
    <p-text class="mt-fluid-md md:mt-fluid-sm"><span [innerHTML]="'signup.password.strength.criteria.label' | translate"></span></p-text>
    <p-text-list>
      <p-text-list-item class="mt-fluid-sm">
        {{ 'signup.password.strength.criteria.hasMinLengthLabel' | translate }}
        @if (hasMinLength) {
          <p-icon color="success" name="check" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.met.aria' | translate }}</span>
        } @else {
          <p-icon color="error" name="close" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.notMet.aria' | translate }}</span>
        }
      </p-text-list-item>
      <p-text-list-item class="mt-fluid-sm">
        {{ 'signup.password.strength.criteria.containsNumbersLabel' | translate }}
        @if (containsNumbers) {
          <p-icon color="success" name="check" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.met.aria' | translate }}</span>
        } @else {
          <p-icon color="error" name="close" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.notMet.aria' | translate }}</span>
        }
      </p-text-list-item>
      <p-text-list-item class="mt-fluid-sm">
        {{ 'signup.password.strength.criteria.containsLowercaseAndUppercaseLabel' | translate }}
        @if (containsLowercaseAndUppercase) {
          <p-icon color="success" name="check" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.met.aria' | translate }}</span>
        } @else {
          <p-icon color="error" name="close" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.notMet.aria' | translate }}</span>
        }
      </p-text-list-item>
      <p-text-list-item class="mt-fluid-sm">
        {{ 'signup.password.strength.criteria.containsSymbolsLabel' | translate }}
        @if (containsSymbols) {
          <p-icon color="success" name="check" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.met.aria' | translate }}</span>
        } @else {
          <p-icon color="error" name="close" aria-hidden="true"></p-icon>
          <span class="sr-only">{{ 'signup.password.strength.criteria.notMet.aria' | translate }}</span>
        }
      </p-text-list-item>
    </p-text-list>
  </div>
}
